'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eutil$002e$002dFailure from "./scala.util.-Failure.js";
import * as $j_scala$002eutil$002e$002dRight from "./scala.util.-Right.js";
import * as $j_scala$002eutil$002e$002dTry from "./scala.util.-Try.js";
import * as $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024 from "./scala.util.control.-Non-Fatal$.js";
var $p;
/** @constructor */
function $c_s_util_Success(value) {
  this.e5 = null;
  this.e5 = value;
}
export { $c_s_util_Success as $c_s_util_Success };
$p = $c_s_util_Success.prototype = new $j_scala$002eutil$002e$002dTry.$h_s_util_Try();
$p.constructor = $c_s_util_Success;
/** @constructor */
function $h_s_util_Success() {
}
export { $h_s_util_Success as $h_s_util_Success };
$h_s_util_Success.prototype = $p;
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-1750213842), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_s_util_Success) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.e5, x$0.e5)));
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 1;
});
$p.o = (function() {
  return "Success";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.e5;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
$p.Pi = (function() {
  return false;
});
$p.Pk = (function() {
  return true;
});
$p.C = (function() {
  return this.e5;
});
$p.P9 = (function(default$1) {
  return this.e5;
});
$p.a6 = (function(f) {
  f.j(this.e5);
});
$p.ra = (function(f) {
  try {
    return new $c_s_util_Success(f.j(this.e5));
  } catch (e) {
    var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
    var x2 = $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024.$m_s_util_control_NonFatal$().ht(e$2);
    if ((!x2.k())) {
      return new $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure(x2.C());
    }
    throw ((e$2 instanceof $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException) ? e$2.aZ : e$2);
  }
});
$p.QL = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Some(this.e5);
});
$p.QG = (function() {
  return new $j_scala$002eutil$002e$002dRight.$c_s_util_Right(this.e5);
});
$p.eT = (function(fa, fb) {
  try {
    return fb.j(this.e5);
  } catch (e) {
    var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
    var x42 = $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024.$m_s_util_control_NonFatal$().ht(e$2);
    if ((!x42.k())) {
      var x43 = x42.C();
      return fa.j(x43);
    }
    throw ((e$2 instanceof $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException) ? e$2.aZ : e$2);
  }
});
function $isArrayOf_s_util_Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gb)));
}
export { $isArrayOf_s_util_Success as $isArrayOf_s_util_Success };
var $d_s_util_Success = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_util_Success, "scala.util.Success", ({
  gb: 1,
  gc: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_s_util_Success as $d_s_util_Success };
